// The portal's button vocabulary, as plain class strings so a page that still
// renders a raw <button> can wear exactly what the Button component wears.
//
// Colour says what the action does, never how loud it should be: `primary` for
// the main action on a screen, `danger` for anything that destroys data, and
// `warning` / `success` for caution and confirmation. Amber and green are
// tinted rather than filled, because neither reaches 4.5:1 against white ink at
// this size; they carry their own dark ink instead.
export const BUTTON_VARIANTS = {
  primary: "bg-brand-600 text-white hover:bg-brand-700 focus-visible:ring-brand-200",
  secondary:
    "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-gray-300 focus-visible:ring-gray-200",
  ghost: "bg-transparent text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus-visible:ring-gray-200",
  danger: "bg-danger-600 text-white hover:bg-danger-700 focus-visible:ring-danger-200",
  dangerSoft: "bg-danger-50 text-danger-700 hover:bg-danger-100 focus-visible:ring-danger-200",
  warning: "bg-warning-200 text-warning-900 hover:bg-warning-300 focus-visible:ring-warning-200",
  success: "bg-success-200 text-success-900 hover:bg-success-300 focus-visible:ring-success-200",
};

export const BUTTON_SIZES = {
  sm: "gap-1.5 rounded-lg px-2.5 py-1.5 text-xs",
  md: "gap-2 rounded-lg px-3.5 py-2 text-[13px]",
  lg: "gap-2 rounded-xl px-5 py-2.5 text-sm",
};

export const BUTTON_BASE =
  "inline-flex items-center justify-center font-semibold transition focus:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-60";

// Ready-made class string, for the pages that still hand-roll their buttons.
export const btn = (variant = "primary", size = "md", extra = "") =>
  `${BUTTON_BASE} ${BUTTON_SIZES[size] ?? BUTTON_SIZES.md} ${
    BUTTON_VARIANTS[variant] ?? BUTTON_VARIANTS.primary
  } ${extra}`.trim();
